export { default } from "./fixed-view"
